module.exports = __webpack_public_path__ + "static/media/pay-button.e2e20d9d.svg";